import React, { PureComponent } from 'react';
import { DLTextArea } from 'appSrc/components/UI';

export default class FormTextArea extends PureComponent {
    render() {
        const { input: { value, name, onChange, onFocus, onBlur }, meta: { error, dirty } } = this.props;
        var props = {
            ...this.props,
            value,
            name,
            onChange,
            onFocus,
            onBlur,
            error: dirty ? error : undefined,
        };

        return (
            <DLTextArea { ...props } />
        );
    }
}

FormTextArea.defaultProps = {
    className: '',
    style: {},
};
